export default "__VITE_ASSET__bf4ea983__"